import React, { Component } from 'react';

import { Table, Modal } from 'antd';
// import echarts from 'echarts';

import components from '../../../components';
import SelectInput from '../../../components/selectinput';

import services from '../../../services';
import layouts from '../../../layouts';

import utils from '../../../utils';


class Query extends Component {
    constructor(props) {
        super(props);

        const session = JSON.parse(sessionStorage.session);

        const defaultKeywords = Object.assign({
            courseName: '',
            employeeId: '',
            realName: '',
            bgTermId: session.account.termId,
            bgTermName: session.account.termName,
            endTermId: session.account.termId,
            endTermName: session.account.termName,
        }, utils.getKeywords());

        this.state = {
            loading: false,
            keywords: defaultKeywords,
            data: [],
            option: {},
            domain: defaultKeywords,
            toggble: false,
            attachment: false,
            pid: '',
            courseData: [],
            employeeData: [],
            list: [],
            header: [],
            dataSource: []

        };

        this.domain = defaultKeywords;

        services.targetAnalysisByTarget.onSelect([]);
    }

    componentDidMount() {
        this.querySearch();
    }

    querySearch() {
        this.setState({
            loading: true
        });
        const domain = Object.assign({}, this.state.keywords, this.domain);
        return services.home.homePageByTeacher.querySearchWaring(domain)
            .then(response => {
                if (response.code === 200) {
                    const data = response.data.dataList;

                    this.setState({
                        loading: false
                    });

                    const columnsData = [{
                        dataIndex: 'orgName',
                        title: '部门名称'
                    }, {
                        dataIndex: 'majorName',
                        title: '专业'
                    }, {
                        dataIndex: 'employeeName',
                        title: '教师姓名'
                    }
                    , {
                        dataIndex: 'finalScore',
                        title: '分数'
                    },{
                        dataIndex: 'descText',
                        title: '描述'
                    },{
                        dataIndex: 'status',
                        title: '预警状态'
                    }, {
                        dataIndex: 'termName',
                        title: '学期'
                    }
                ];
                    const header = columnsData;
                 
                    const dataSource = (data || []);
                    this.setState({
                        header,
                        dataSource,
                    });

                } else {
                    this.setState({
                        loading: false
                    });
                }

            }).catch(error => {
                this.setState({
                    loading: false
                });
            });
    }

    render() {
        const dataSource = this.state.dataSource;
        const size = dataSource.length;
        return (
            <layouts.ViewPort>
                <layouts.Search classNames='2'>
                    <div className={this.state.toggble ? "root-search-wrapper search-toggle-open" : "root-search-wrapper"}>
                        <div className="search-item" >
                            <div style={{float:'left'}}>
                                <h3>预警及参评率信息</h3>
                            </div>
                        </div>
                    </div>
                </layouts.Search>
                <div className="root-file root-file-new">
                    <div class="root-graph-view">
                        <div className="root-chart-line" style={{height: 400,width:'100%'}}>
                        {
                            size ? <Table bordered={true} columns={this.state.header} dataSource={this.state.dataSource} pagination={false} size="small" /> : ''
                        }
                        </div>
                    </div>
                </div>
            </layouts.ViewPort>
        )
    }
}

export default Query;